// Module
var code = "<ui-view></ui-view> ";
// Exports
var _module_exports = code;;
var path = 'machines/common/Pages/detail/commission/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;